import { OPERATION_LOG_MAP } from '@gp/constants/operationLogParams';
import {
  ButtonLogParams,
  IRecord,
  MenuResultType,
  PageLogParams,
  QCouldResTypes,
  SearchLogParams,
} from '@gp/types/global';
import http from '@gp/utils/httpTS';

import type { IBaseResponse } from '@home/types/common';

// 暂时需要隐藏的菜单栏
const TEMP_HIDE_MENU_ITEM = [
  // 'studio_monthly_report',
  // 'studio_dashboard',
  // 'workspace',
  // 'add_new_product',
  'newsletter',
  'studio_business_metrics',
];

// 过滤掉没有权限时需要隐藏掉的菜单
const filterSecondMenus = (list: any[]): any[] => {
  if (!Array.isArray(list)) return [];
  return list
    .filter(item => !TEMP_HIDE_MENU_ITEM?.includes(item?.page_id))
    .map(item => {
      const newSubMenus = Array.isArray(item?.sub_menus)
        ? filterSecondMenus(item?.sub_menus)
        : item?.sub_menus;
      return {
        ...item,
        sub_menus: newSubMenus,
      };
    });
};

// 获取菜单列表
export const getLeftMenuList: () => Promise<MenuResultType[]> = () => {
  return http.get('/api/v1/globalpedia_pc/listMenuV2', {
    formatData: data => {
      if (!data) return [];
      const _resList = data?.menu_list?.[0]?.sub_menus;
      // 当Newsletter全部都没有权限时不显示出来Newsletter
      const resList =
        _resList
          ?.map((t: any) => {
            // 隐藏Newsletter、Globalpedia
            if (
              t?.page_id === 'newsletter' ||
              t?.page_id === 'globalpedia' ||
              t?.page_id === 'workspace' ||
              (t?.page_id === 'add_new_product' && t?.authority !== 1)
            ) {
              // const flag = t?.sub_menus?.some((t: any) => t?.authority === 1);
              // return flag;
              return null;
            }
            let newSubMenus = t?.sub_menus;
            if (Array.isArray(t?.sub_menus)) {
              newSubMenus = t?.sub_menus
                ?.map((it: any) => {
                  // 隐藏My Workspace-Product Review
                  if (it?.page_id === 'gate_review') {
                    return null;
                  }
                  return it;
                })
                ?.filter((it: any) => !!it);
            }
            return {
              ...t,
              sub_menus: newSubMenus,
            };
          })
          ?.filter((t: any) => !!t) || _resList;
      // return resList;
      return filterSecondMenus(resList);
      // return filterSecondMenus(resList)?.filter(
      //   item => !!item?.assembly_url || !!item?.sub_menus?.length,
      // );
    },
  });
};

// 获取数据更新时间
export const getUpdateTime: () => Promise<string> = () => {
  return http.get('/api/v1/globalpedia_pc/getTime');
};

// 页面级打点上报日志信息
export const reportOperationLog: (
  params: PageLogParams | ButtonLogParams | SearchLogParams,
  type?: 'page' | 'button' | 'search',
) => void = (params, type = 'page') => {
  const openId = sessionStorage.getItem('openId') || '';
  const baseParams = OPERATION_LOG_MAP?.[type] || {};
  let newParams;
  try {
    newParams = {
      ...baseParams,
      openId,
      [`${type}Log`]: {
        // @ts-ignore
        ...baseParams?.[`${type}Log`],
        ...params,
      },
    };
  } catch (error) {
    newParams = baseParams;
  }
  return http.post('/api/v1/permission/operationLog', newParams, {
    errorHandler: true,
  });
};

// 获取所有国家国旗
export const getCountryFlags: () => Promise<string> = () => {
  return http.get('/api/v1/globalpedia_pc/country/flags');
};

// 获取引导是否完成，注意：当接口有改动或返回字段格式有变时，情报系统也需要改，对应上
export const queryGuideInfo: (params: {
  page: string;
}) => Promise<boolean> = params => {
  return http.get('/api/v1/globalpedia_pc/guide_info', { params });
};

// 引导完成通知后台
export const updateGuide: (params: {
  page: string;
}) => Promise<boolean> = params => {
  return http.post('/api/v1/globalpedia_pc/edit_guide', params);
};

// 获取页面的查看权限
export const queryPageAuthority = (params: {
  assort:
    | 'studio_overall' // 类别，区分哪个页面
    | 'single_studio'
    | 'game_detail'
    // | 'pr_add'
    | (string & {});
  id?: string; // 公司id或游戏id，可以为空
  project_id?: string | number | null; // 详情页传这个id
}): Promise<{ [keyName: string]: boolean }> => {
  return http.get('/api/v1/globalpedia_pc/getPageAuthority', { params });
};

// 获取指定tableauSiteId的 tableau访问url
export const queryTableauUrl = (params: {
  tableau_site_id: string;
}): Promise<{
  full_url_inner: string;
  full_url: string;
}> => {
  return http.post('/api/v1/globalpedia_pc/getTicket', params);
};

// 获取gp原有存储桶信息，新加坡
export const getGPOPTencentQCouldMassage = (
  uploadFolderName?: string,
): Promise<QCouldResTypes> => {
  return http({
    url: '/api/v1/globalpedia_pc/tencent_qcloud/auth',
    method: 'get',
    params: uploadFolderName ? { path: uploadFolderName } : {},
  }) as Promise<QCouldResTypes>;
};

// 获取bids存储桶信息，广州
// export const getBIDSTencentQCouldMassage = (): Promise<QCouldResTypes> => {
//   return http.get('/api/v1/globalpedia_pc/studio_management/tencent_qcloud/auth');
// };
export const getBIDSTencentQCouldMassage = (
  uploadFolderName?: string,
): Promise<QCouldResTypes> => {
  return http({
    url: '/api/v1/globalpedia_pc/studio_management/tencent_qcloud/auth',
    method: 'get',
    params: uploadFolderName ? { path: uploadFolderName } : {},
  }) as Promise<QCouldResTypes>;
};

export const fetchTipsViewState = (params: {
  tags: string;
}): IBaseResponse<IRecord<boolean>> => {
  return http({
    method: 'get',
    url: '/api/v1/globalpedia_pc/support/tip/queryTagViewState',
    params,
    rawData: true,
  });
};

export const setTipsViewStateTrue = (params: {
  tags: string;
}): IBaseResponse<any> => {
  return http({
    method: 'post',
    url: '/api/v1/globalpedia_pc/support/tip/setTipViewState',
    params,
    rawData: true,
  });
};
